import api from './index';
//
let exports = {};

// 报名前检查
exports.checkBidEnroll = function (id, callback) {// 验证报名
    api.post('/tendBid/enroll/check/do')
    .params({
        id: id
    })
    .done(callback)
    .go();
};
// 获取报名的详细信息
exports.getBidEnrollInfo = function (params, callback) {// 获取报名详细信息
    api.post('/tendBid/enroll/info/get')
    //.sync(true)
    .data(params)
    .done(callback)
    .go();
};
// 保存（申请）报名信息
exports.saveBidEnroll = function (params, callback) {// 保存报名信息
    api.post('/tendBid/enroll/save/do')
    .data(params)
    .done(callback)
    .go();
};
// 报名列表
exports.getBidEnrollList = function (params, callback) {// 获取报名列表
    api.post('/tendBid/enroll/list/get')
    .data(params)
    .done(callback)
    .go();
};
// 报名申请
exports.applyBidEnroll = function (params, callback) {// 申请报名
    api.post('/tendBid/enroll/apply/do')
    .data(params)
    .done(callback)
    .go();
};
//报名审核
exports.auditBidEnroll = function (params, callback) {// 报名内部审核
    api.post('/tendBid/enroll/audit/do')
    .data(params)
    .done(callback)
    .go();
};
//报名审核记录
exports.getBidEnrollAuditRecList = function (params, callback) {// 获取报名内部审核记录列表
    api.post('/tendBid/enroll/audit/rec/list/get')
    .data(params)
    .done(callback)
    .go();
};

// 保存投标信息
exports.saveBidDoc = function (params, callback) {// 创建投标书
    api.post('/tendBid/doc/save/do')
    .data(params)
    .done(callback)
    .go();
};

// 获取投标列表
exports.getBidDocList = function (params, callback) {// 获取投标列表
    api.post('/tendBid/doc/list/get')
    .data(params)
    .done(callback)
    .go();
};

// 获取投标详情
exports.getBidDocInfo = function (data, callback) {// 获取投标详情
    api.post('/tendBid/doc/info/get')
    .data(data)
    .done(callback)
    .go();
};

// 投标申请
exports.applyBidDoc = function (params, callback) {// 投标申请
    api.post('/tendBid/doc/apply/do')
    .data(params)
    .done(callback)
    .go();
};

// 投标审核
exports.auditBidDoc = function (params, callback) {// 投标审核
    api.post('/tendBid/doc/audit/do')
    .data(params)
    .done(callback)
    .go();
};

// 投标审核记录
exports.getBidAuditRecListByDocId = function (params, callback) {// 获取投标审核记录列表
    api.post('/tendBid/audit/rec/list/get/by/docId')
    .data(params)
    .done(callback)
    .go();
};

// 投标商务条款
exports.getBidTermList = function (params, callback) {// 获取条款列表
    api.post('/tendBid/term/list/get')
    .data(params)
    .done(callback)
    .go();
};

// 检查是否已经投标
exports.getBidDocCheckResult = function (params, callback) {// 验证投标
    api.post('/tendBid/doc/check/result/get')
    .data(params)
    .done(callback)
    .go();
};
//
exports.getBidActRecListByDocId = function (params, callback) {
    api.get('/tendBid/act/rec/list/get/by/docId')
    .params(params)
    .done(callback)
    .go();
};
//
export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/tendBid.js
// module id = 58
// module chunks = 1